import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import Popper from "@mui/material/Popper";
import { AutoSelectProps } from "./auto-select-props";
import FormControl from "@mui/material/FormControl";
import { ErrorMessage } from "formik";
import Box from "@mui/material/Box";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./auto-search-select.scss";
const CustomPopper = (props: any) => (
  <Popper
    {...props}
    placement="bottom-start"
    modifiers={[
      {
        name: "flip",
        enabled: false,
      },
      {
        name: "preventOverflow",
        enabled: true,
        options: {
          boundary: "viewport",
        },
      },
    ]}
  />
);

const SearchableAutoSelect: React.FC<AutoSelectProps> = ({
  options,
  onChange,
  value,
  fieldName,
  placeholder,
  isShowError,
  handleBlur,
}) => {
  return (
    <Box>
      <div className="form-auto-select-component">
        <FormControl fullWidth error={!!isShowError}>
          <Autocomplete
            disablePortal
            options={options}
            getOptionLabel={(option) => {
              if (typeof option === "string") return option;
              if (!option) return "";
              return option.value || option.label || "";
            }}
            getOptionDisabled={(option) => option?.disabled === true}
            value={value}
            onChange={(_, newValue) => onChange(newValue?.value, newValue)}
            onClose={() => {
              if (handleBlur) {
                handleBlur();
              }
            }}
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={placeholder}
                variant="outlined"
                InputLabelProps={{ shrink: false }}
              />
            )}
            PopperComponent={CustomPopper}
            popupIcon={<ExpandMoreIcon />}
            sx={{
              "& .MuiOutlinedInput-root": {
                paddingRight: 0,
                paddingLeft: "9px",
                padding: 0,
              },
            }}
          />
        </FormControl>
        {isShowError && (
          <ErrorMessage
            name={fieldName || ""}
            component="div"
            className="error-message"
          />
        )}
      </div>
    </Box>
  );
};

export default SearchableAutoSelect;
